// API helper functions
import { getSessionId } from './session';

// API Configuration - detect environment and set API base URL
(function() {
  // If running on HTTPS (Vercel), use relative URLs to avoid Mixed Content
  // The API will be proxied through Vercel serverless functions
  // Always use relative URLs - Vercel serverless functions handle /api/* routes
  (window as any).API_BASE_URL = '';
  // Store a flag to indicate we're using relative URLs
  (window as any).USE_RELATIVE_API = true;
})();

export function getApiUrl(path: string): string {
  // Check if scene_id is already in the path
  const hasSceneId = path.includes('scene_id=');
  
  if ((window as any).USE_RELATIVE_API || (window as any).API_BASE_URL === '') {
    // Remove leading slash if path already has it
    const cleanPath = path.startsWith('/') ? path : '/' + path;
    // Only append session if scene_id is not present
    if (!hasSceneId) {
      const sid = getSessionId();
      if (sid) {
        return cleanPath + (cleanPath.includes('?') ? '&' : '?') + 'session=' + encodeURIComponent(sid);
      }
    }
    return cleanPath;
  }
  // Fallback for local development when API_BASE_URL is explicitly set
  const base = (window as any).API_BASE_URL || 'http://localhost:8002';
  const cleanPath = path.startsWith('/') ? path : '/' + path;
  const url = `${base}${cleanPath}`;
  // Only append session if scene_id is not present
  if (!hasSceneId) {
    const sid = getSessionId();
    if (sid) {
      return url + (url.includes('?') ? '&' : '?') + 'session=' + encodeURIComponent(sid);
    }
  }
  return url;
}

